/**
 * @function
 * @description General-use Fetch API response parser
 * @param {Promise} response Promise containing the response
 * @returns {*} Extracted JSON body content of the response
 */
module.exports = (response) => {
      if (response.status === 401) {
        localStorage.removeItem(`token`);
        localStorage.removeItem(`temtoken`);
        localStorage.removeItem(`user`);
        localStorage.removeItem(`source`);
        localStorage.removeItem(`profilePicture`);
        localStorage.removeItem(`backgroundColor`);
        localStorage.removeItem(`initial`);
        localStorage.removeItem('deviceToken');
        window.location.href = '/?login=true';
        return;
    }
    if (!response.ok) throw Error(response.statusText);
     return response.json();
};
